document.addEventListener("DOMContentLoaded", () => {
    console.log("Custom TS Loaded!");
  
    // Spinner Function
    const spinner = () => {
      setTimeout(() => {
        const spinnerElement = document.getElementById("spinner");
        if (spinnerElement) {
          spinnerElement.classList.remove("show");
        }
      }, 1);
    };
    spinner();
  
    // Back to Top Button
    const backToTopBtn = document.querySelector(".back-to-top") as HTMLElement;
    if (backToTopBtn) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
          backToTopBtn.style.display = "block";
        } else {
          backToTopBtn.style.display = "none";
        }
      });
  
      backToTopBtn.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  
    // Sidebar Toggler
    const sidebarToggler = document.querySelector(".sidebar-toggler");
    const sidebar = document.querySelector(".sidebar");
    const content = document.querySelector(".content");
  
    if (sidebarToggler && sidebar && content) {
      sidebarToggler.addEventListener("click", (e) => {
        e.preventDefault();
        sidebar.classList.toggle("open");
        content.classList.toggle("open");
      });
    }
  
    // Progress Bar (If waypoints were used, consider a Vue alternative)
    /* const progressBars = document.querySelectorAll(".progress .progress-bar");
    window.addEventListener("scroll", () => {
      progressBars.forEach((bar) => {
        const element = bar as HTMLElement;
        const value = element.getAttribute("aria-valuenow");
        if (value) element.style.width = value + "%";
      });
    }); */
  
    // Calendar (If using a DateTime picker library, use its Vue equivalent)
    /* import 'tempusdominus-bootstrap-4';
    const calender = document.getElementById("calender");
    if (calender) {
      new tempusDominus.TempusDominus(calender, { display: { inline: true } });
    } */
  
    // Testimonials Carousel (Replace OwlCarousel with Swiper.js)
    /* import Swiper from 'swiper';
    new Swiper('.testimonial-carousel', {
      autoplay: { delay: 3000 },
      speed: 1000,
      loop: true,
      pagination: { el: '.swiper-pagination', clickable: true },
    }); */
  });
  